<template>
<div class="content2">
  <div>
    <el-button type="primary" @click="exportExcel">导出年度诉讼计划模板</el-button>
    <el-button type="primary" @click="importLegalPlanExcel">导入年度诉讼计划</el-button>

<!--    <el-date-picker-->
<!--      style="width: 150px"-->
<!--      v-model="where.start_time"-->
<!--      size="mini"-->
<!--      type="month"-->
<!--      format="yyyy-MM"-->
<!--      value-format="yyyy-MM" placeholder="计划月份">-->
<!--    </el-date-picker>-->
  </div>

  <div class="header-tip">
    <div>导入项目数：{{pageData.yes_count||0}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未导入项目数：{{pageData.no_count||0}}</div>
  </div>

  <div class="table-wrap">
    <el-table
      v-loading="loading"
      v-if="pageData" :data="pageData.list"
      border
      style="width: 100%" height="65vh">
<!--      <el-table-column-->
<!--        align="center"-->
<!--        prop="zq_region_name"-->
<!--        label="战区"-->
<!--        width="120" fixed>-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        align="center"-->
<!--        prop="pq_region_name"-->
<!--        label="片区"-->
<!--        width="120" fixed>-->
<!--      </el-table-column>-->
      <el-table-column
        align="center"
        prop="name"
        label="名称"
        width="200" fixed>
      </el-table-column>
      <el-table-column
        align="center"
        label="2024年12月31日诉讼状态">
        <el-table-column
          align="center"
          prop="last_year_no_tj_num"
          label="未提交"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="last_year_tj_num"
          label="提交"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="last_year_st_num"
          label="诉调"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="last_year_la_num"
          label="立案"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="last_year_hj_num"
          label="合计"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        prop="year_num"
        label="2025年新增"
        width="100">
        <template slot-scope="scope">
          <el-link type="primary" @click="provalPlan(scope.row,'')">{{formatMoney(scope.row.year_num)}}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="year_total_count"
        label="总计划"
        width="100">
      </el-table-column>

      <el-table-column v-for="(field,index) in year_month_fields" :key="index"
                       align="center"
                       :label="field.label">
        <el-table-column v-for="(child,index2) in field.children" :key="index2"
                         align="center"
                         :prop="child.prop"
                         :label="child.label"
                         width="120">
          <template slot-scope="scope">
            <div v-if="scope.row[child.prop]!==null&&child.type==='count'">
              <el-link type="primary" @click="provalPlan(scope.row,child.month)">{{formatMoney(scope.row[child.prop])}}</el-link>
            </div>
            <div v-if="scope.row[child.prop]!==null&&child.type==='amount'">
              {{formatMoney(scope.row[child.prop],2)}}
            </div>
          </template>
        </el-table-column>
      </el-table-column>

    </el-table>

  </div>
<!--  <div class="pagination-wrap">-->
<!--    <el-pagination background layout="prev, pager, next" :total="pageData.total*1"-->
<!--                   :page-size="pageData.pageSize*1" :current-page="pageData.page*1"-->
<!--                   @current-change="pageChange"></el-pagination>-->
<!--  </div>-->

  <el-dialog
    :visible.sync="dialogVisible"
    width="400px">
    <div>
      <el-descriptions :column="1">
        <el-descriptions-item label="开始时间">
          <el-date-picker
            v-model="form_data.start_time"
            type="month"
            size="mini"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="选择日期">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="结束时间">
          <el-date-picker
            v-model="form_data.end_time"
            type="month"
            size="mini"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="选择日期">
          </el-date-picker>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <template #footer>
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button @click="exportExcel">导出</el-button>
    </template>
  </el-dialog>

  <HouseUrgeLockHistoryDialog ref="houseUrgeLockHistoryDialog" />
</div>
</template>

<script>
import moment from "moment/moment";
import Http from "../../common/Http";
import {CommonHelp} from "../../common/CommonHelp";
import ButlerHttp from "../../common/ButlerHttp";
import HouseUrgeLockHistoryDialog from "./HouseUrgeLockHistoryDialog";

export default {
  name: "ExpeditingFeesPlanContenzioso",
  components: {HouseUrgeLockHistoryDialog},
  inject:['where','reginWhere'],
  data(){
    function fields() {
      let fields = [];
      for (let i = 1; i <= 12; i++) {
        let field_obj={
          label: `${i}月计划`,
          children: [
            {
              prop: `month_${i}_count`,
              label: "户数",
              type: "count",
              width: 100,
              align: "center",
              month: moment().month(i-1).format("YYYY-MM")
            },
            {
              prop: `month_${i}_amount`,
              label: "金额",
              type: "amount",
              width: 100,
              align: "center"
            }
          ]
        }
        fields.push(field_obj);
      }
      return fields;
    }
    return{
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      dialogVisible:false,
      form_data:{
        start_time: moment(new Date()).format("YYYY-MM"),
        end_time: moment(new Date()).format("YYYY-12")
      },
      year_month_fields:fields()
    }
  },
  mounted() {
    const that=this;
    that.getList();
  },
  methods:{
    searchList(){
      this.pageData= {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      };
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      where.level=that.reginWhere.level;

      ButlerHttp.post("LegalPlan/getLegalPlanLevelList",{
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      },res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
      });

      // ERP.postRequest({
      //   url: "admin/LegalStatistics/诉讼状态计划分配表列表",
      //   data: {
      //     ...where,
      //     page: that.pageData.page,
      //     page_size: that.pageData.pageSize
      //   }
      // }, res => {
      //   if (res.code) {
      //     that.pageData = res.data
      //   }
      //   that.loading = false;
      // })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    exportExcel(){
      const that=this;
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
      }
      ButlerHttp.post("LegalPlan/getExcel", {
        ...where,
      },res => {
        loading.close()
        if (res.code) {
          window.open(res.data)
        } else {
          that.$message.error(res.msg);
        }
      });
      // ERP.postRequest({
      //   url: "admin/LegalStatistics/getExcel",
      //   data: {
      //     ...where,
      //   }
      // }, res => {
      //   loading.close()
      //   if (res.code) {
      //     window.open(res.data)
      //   }else {
      //     that.$message.error(res.msg);
      //   }
      // })
    },
    importLegalPlanExcel(){
      const that=this;
      ButlerHttp.uploadFile(file=>{
        const loading=that.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ButlerHttp.post("LegalPlan/importExcelFlow", {
          file:file,
        },res => {
          loading.close()
          if (res.code) {
            let timeStr=(new Date()).getTime()
            ERP.navigateTo(`/flow/FlowView?sheet_id=173&master_id=140&timeValue=${timeStr}&batch_number=${res.data}`)
            // that.pageChange(1);
          }else {
            that.$message.error(res.msg);
          }
        });
      })
      //   ERP.postRequest({
      //     url: "admin/LegalStatistics/诉讼状态计划分配表导入",
      //     data: {
      //       file:file,
      //     }
      //   }, res => {
      //     loading.close()
      //     if (res.code) {
      //       let timeStr=(new Date()).getTime()
      //       ERP.navigateTo(`/flow/FlowView?sheet_id=141&master_id=115&timeValue=${timeStr}&batch_number=${res.data}`)
      //       // that.pageChange(1);
      //     }else {
      //       that.$message.error(res.msg);
      //     }
      //   })
      // })
    },
    round(val,num=2) {
      return Math.round(val*100)/100
    },
    provalPlan(row,month=''){
      const that=this;
      that.$refs.houseUrgeLockHistoryDialog.show({
        url:"ProjectCollectionProceedingPlanHouse/index3",
        project_ids:row.project_ids,
        area_ids:row.area_ids,
        area_id:row.area_id,
        year_month:month,
        urge_types:'诉讼,第三方诉讼,第三方管理',
        debt_age_type:row.age_type_text,
      });
    }
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where.start_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../common";
.content2{
  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
  .table-wrap{
    height: unset !important;
  }
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: flex;
    flex-direction: row;

    .header-tip-body{
      //width: 500px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      //justify-content: space-between;
      .header-tip-body-item{
        margin-left: 50px;
        display: flex;
        flex-direction: row;
      }
    }
  }
  .pagination-wrap{
    margin-top: 5px;
    text-align: center;
  }

  >>>.el-table--border, .el-table--group{
    border: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
    border-bottom: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/ExpeditingFeesPlanContenzioso.vue